import React from 'react';
import {
    AppstoreAddOutlined ,
    FileTextOutlined,
    GoldOutlined,
    DollarOutlined
} from '@ant-design/icons';
import {
    Card,
    Statistic,
    Typography
} from 'antd';

function SalesCard({ cardTemplate,cardData }) {
    return (
        <Card
            bordered={false}
            bodyStyle={{
                background: cardTemplate.cardBg,
                borderRadius: "8px",
                padding: '16px',
                position: 'relative'
            }}
        >
            {
                cardTemplate.key === 'orders' && <FileTextOutlined
                    style={{
                        background: cardTemplate.iconBg,
                        color: cardTemplate.iconColor,
                        padding: '8px',
                        position: 'absolute',
                        borderRadius: '4px'
                    }} />
            }
            {
                cardTemplate.key === 'received' && <AppstoreAddOutlined
                    style={{
                        background: cardTemplate.iconBg,
                        color: cardTemplate.iconColor,
                        padding: '8px',
                        position: 'absolute',
                        borderRadius: '4px',
                    }} />
            }
            {
                cardTemplate.key === 'transfer' && <GoldOutlined
                    style={{
                        background: cardTemplate.iconBg,
                        color: cardTemplate.iconColor,
                        padding: '8px',
                        position: 'absolute',
                        borderRadius: '4px'
                    }} />
            }
            {
                cardTemplate.key === 'revenue' && <DollarOutlined
                    style={{
                        background: cardTemplate.iconBg,
                        color: cardTemplate.iconColor,
                        padding: '8px',
                        position: 'absolute',
                        borderRadius: '4px'
                    }} />
            }
            <Statistic
                title={
                    <Typography.Title
                        level={5}
                        style={{
                            padding: 0,
                            margin: 0,
                            color: cardTemplate.textColor,
                            textAlign: 'center'
                        }}>{cardTemplate.label}</Typography.Title>
                }
                value={cardData[cardTemplate.key]}
                precision={0}
                valueStyle={{
                    color: cardTemplate.valueColor,
                    textAlign: 'center',
                    fontWeight: 'bold'
                }}
            // prefix={}
            // suffix={cardTemplate.unit}
            />
        </Card>

    )
}

export default SalesCard